/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import HospitalsidHospital from './HospitalsidHospital';

/**
 * The SurgeonsIdBody model module.
 * @module model/SurgeonsIdBody
 * @version v0.3
 */
export default class SurgeonsIdBody {
  /**
   * Constructs a new <code>SurgeonsIdBody</code>.
   * @alias module:model/SurgeonsIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>SurgeonsIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SurgeonsIdBody} obj Optional instance to populate.
   * @return {module:model/SurgeonsIdBody} The populated <code>SurgeonsIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SurgeonsIdBody();
      if (data.hasOwnProperty('surgeon'))
        obj.surgeon = HospitalsidHospital.constructFromObject(data['surgeon']);
    }
    return obj;
  }
}

/**
 * @member {module:model/HospitalsidHospital} surgeon
 */
SurgeonsIdBody.prototype.surgeon = undefined;

